// Global light/dark theme for the whole app (public site + admin).
// The `dark` class on <html> flips every theme token in index.css
// (:root = light, .dark = dark). Default is dark; a saved
// localStorage 'isDarkMode' = 'false' opts into light.
// To add a toggle later: call setIsDarkMode (App context) and save the
// choice with localStorage.setItem(THEME_STORAGE_KEY, String(isDark)).
export const THEME_STORAGE_KEY = 'isDarkMode';

export const getStoredDarkMode = () => {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    return stored === null || stored === 'true';
  } catch {
    return true;
  }
};

export const applyDarkMode = (isDark) => {
  document.documentElement.classList.toggle('dark', isDark);
};
